import { FC } from 'react';
import DrawerMenuItem from './menu-item';
import Divider from '@mui/material/Divider';
import { UpdateMenuItemProps } from './helpers';

const UpdateMenuItems: FC<Omit<UpdateMenuItemProps, 'showUpdateMenu'>> = ({
  onEdit,
  onDelete,
  canEdit = true,
  canDelete = false,
  editSubtitle,
  deleteSubtitle,
}) => {
  const hasEdit = !!onEdit;
  const hasDelete = !!onDelete;
  if (!hasEdit && !hasDelete) {
    // This generally should not happen, but handling in case
    return null;
  }

  return (
    <>
      <Divider />
      {hasEdit && (
        <DrawerMenuItem
          onClick={onEdit}
          label="Edit"
          subtitle={editSubtitle}
          disabled={!canEdit}
          icon="edit"
        />
      )}
      {hasDelete && (
        <DrawerMenuItem
          onClick={onDelete}
          label="Delete"
          subtitle={deleteSubtitle}
          disabled={!canDelete}
          icon="delete"
          color="error"
        />
      )}
    </>
  );
};

export default UpdateMenuItems;
